import styled, { keyframes } from 'styled-components';
import Text from 'components/Text';

export const AvatarText = styled(Text.Default)`
  font-size: 1.5em;
  color: #fff;
`;

export const IconContain = styled.div`
  position: relative;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  z-index: 9999;
  background-color: ${(props) => props.theme.brandColor};
  will-change: background-color;
  cursor: pointer;

  &:hover {
    background-color: rgba(0, 118, 189, 0.85);
  }
`;

export const IconOuterContain = styled.div``;

export const Flex = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
`;

export const FlexCol = styled.div`
  display: flex;
  align-items: flex-end;
  margin-right: 16px;
  flex-direction: column;
`;

export const MarginLeft = styled.div`
  margin-left: 16px;
`;

const zoomIn = keyframes`
  0% {
    transform: scale(0, 0); 
  }
  100% {
    transform: scale(1.0, 1.0); 
  }
`;

export const PanelContain = styled.div`
  top: 30px;
  width: 400px;
  left: -400px;
  z-index: 999999;
  overflow: hidden;
  position: absolute;
  background-color: #fff;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px,
    rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;

  transform: scale(0, 0);
  animation-duration: 0.15s;
  animation-name: ${zoomIn};
  animation-fill-mode: forwards;
  animation-timing-function: ease-out;
  transform-origin: 100% 0%;

  ${(props) => props.theme.media.sm.max`
      top: 60px;
      width: 100vw;
      left: calc(-100vw + 64px);
    `}
`;

export const Padding = styled.div`
  padding: 24px;
`;

export const LinksContain = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Link = styled.a`
  font-weight: 400;
  font-size: 1em;
  padding-left: 8px;
  line-height: 2em;
  border-radius: 2px;
  font-family: Roboto;
  margin-bottom: 8px;
  box-shadow: 0px 0px 0px 1px #ecf4fa;
  color: ${(props) => props.theme.brandColor};
  display: flex;
  align-items: center;
  will-change: background-color;

  &:hover {
    background-color: rgba(0, 118, 190, 0.05);
  }
`;

export const UserContain = styled.div`
  margin-bottom: 8px;
  background-color: #f2f8fb2e;
  padding: 16px;
  box-shadow: 0px 0px 0px 1px #ecf4fa;
  border-radius: 2px;
`;

export const LinkText = styled.span`
  left: 8px;
  position: relative;
`;

export const Online = styled.div`
  height: 6px;
  width: 6px;
  position: relative;
  top: -2px;
  margin-right: 8px;
  border-radius: 9999px;
  background-color: #4caf50;
`;
